// A team member's name as live shows it, one rule for every screen that names a creator: the
// library's creator chips, an actor's "CREATED BY" and a generation's detail header.
import type { Member } from "../api/generated/model";

/** Their name, else their email before the "@", else live's "Unknown" (no such member). */
export function memberName(member: Member | undefined): string {
  return member?.name ?? member?.email?.split("@")[0] ?? "Unknown";
}
